import { getValueAtPath, withProperties } from "../../../../utils";
import withReactiveFields from "../../helpers/reactivefields";
import { USES_CHARGE_POLLING } from "../../../../charge/flags";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";
import RedirectView from "../../common/redirect";
import withInputFields from "../../helpers/inputfields";
import { CHECKOUT_CLOSE_EVENT } from "../../../helpers/tokens";
import { eNairaPaymentOptions, selectEnairaPaymentOptionFromList } from "../../../../collections/enairaoptions";
import PendingView from "../../common/pending";
import ErrorState from "../../../common/error";

import QRView from "./views/code";
import InitView from "./views/init";
import OTPView from "./views/otp";
import withCountdownTimer from "../../helpers/countdowntimer";



const METHOD = 'enaira';
const METHOD_NAME = 'eNaira';
const CHARGE_MODE = USES_CHARGE_POLLING;

const VIEWS = [ InitView, QRView, OTPView ];

function mount() {
  return (dispatch) => {
    // Some logic here to determine the view to show instead of
    // always showing the bank (first) view, nd also other stuffs
    // like fee check, limit check, etc.
    getChargeLimit.call(this, () => {
      const VIEW = (
        this.QR_CODE && (QRView || this.$resetContext())
      ) || (
        this.REDIRECT_URL && (RedirectView || this.$resetContext())
      ) || (
        this.SHOULD_VALIDATE_CHARGE && (OTPView || this.$resetContext())
      ) || InitView;
      
      VIEW && VIEW.activate.call(this);
    });
    
    getChargeFee();
  };
}

function getChargeData() {
  return ({
    payment_type: 'enaira'
  });
}

function getViewsContext(data, store) {
  const TIMER_DURATION = 5 * 60;
  const REACTIVE_FIELDS = [
    'CURRENT_TIME',
    'REDIRECT_URL',
    'CAN_GO_BACK',
    'QR_CODE',
    'SHOULD_VALIDATE_CHARGE'
  ];

  const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);

  withInputFields($context, {
    otp: null,
    phone: getValueAtPath(data, 'phone') || null,
    eNairaPaymentOption: {
      options: eNairaPaymentOptions,
      selector: selectEnairaPaymentOptionFromList.bind($context, eNairaPaymentOptions),
      defaultValue: eNairaPaymentOptions[0]
    }
  })

  $context.cancelOption = () => {
    $context.$resetContext();
    InitView.activate.call($context);
  }

  $context.$subscribe('REDIRECT_URL', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue && oldValue === currentValue) && currentValue instanceof URL) {
        RedirectView && RedirectView.activate.call($context);
      }
    }, 0);
  });

  $context.$subscribe('QR_CODE', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!oldValue && currentValue && oldValue !== currentValue) {
        QRView && QRView.activate();
      }
    }, 0);
  });

  $context.CAN_GO_BACK = true;

  $context.$subscribe('SHOULD_VALIDATE_CHARGE', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!(oldValue || oldValue === currentValue) && currentValue === true) {
        OTPView && OTPView.activate();
        $context.CAN_GO_BACK = true;
      }
    }, 0);
  });

  withProperties($context, {
    TIMER_DURATION,
    $resetContext() {
      $context.$inputs.$reset('otp');
      $context.$inputs.$reset('phone');
      $context.CAN_GO_BACK = false;
      $context.REDIRECT_URL =  $context.QR_CODE = $context.SHOULD_VALIDATE_CHARGE = null;
    },

    INIT_VIEW: callback => {
      let isValidateCharge = 
        getValueAtPath($context, 'SHOULD_VALIDATE_CHARGE') === true && 
        getValueAtPath($context.$inputs, 'eNairaPaymentOption.value.identifier') === 'TOKEN';
        
      if (!isValidateCharge) {
        InitView && (
          $context.$resetContext(),
          InitView.activate(callback)
        );
      }
    }
  });

  return withCountdownTimer($context, {
    duration: TIMER_DURATION,
    onTick() { $context.CURRENT_TIME = $context.$timer.current },
    onFinish() {
      if ($context.$charge.cancel()) {
        $context.$timer && $context.$timer.clear();
        $context.CURRENT_TIME = null;
        $context.$resetContext();
        setTimeout(() => {
          ErrorState.actions.updateErrorMessage('');
          PendingView && PendingView.activate.call($context);
        }, 10)
      }
    }
  })
}

export {
  METHOD,
  METHOD_NAME,
  CHARGE_MODE,
  VIEWS,
  mount,
  getChargeData,
  getViewsContext
}
